import { Currency } from '@ps/web-core-enums';
import type { TrackedTranslation } from '@ps/web-core-intl';
import type { Error as ValidationError, Validator } from '@ps/web-shared-validators';
import { get } from 'lodash';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import { convertAmountByRate } from '../utils/cashier';

type ValidatorFunction = (
  compareValue: number,
  message: ValidationError['message'],
  allowEmpty: boolean
) => (value: number) => ValidationError;

export const validateAmountLimit =
  (
    validator: ValidatorFunction,
    translationTag: TrackedTranslation,
    amount: number | undefined,
    fieldName: string,
    rate: number
  ): Validator =>
  (value, allValues) => {
    if (!amount || value === '' || parseFloat(value) === 0) return { valid: true };

    const currency = get(allValues, `${fieldName}.currency`);

    let limit =
      currency !== Currency.USDollar && !!rate && !isNaN(rate)
        ? convertAmountByRate(amount, rate, currency, true)
        : amount;

    if (currency === Currency.BritishPound && limit < 1) {
      limit = 1;
    }

    return validator(
      limit,
      {
        ...translationTag,
        values: {
          0: <CurrencyAmount value={limit * 100} currency={currency} />
        }
      },
      true
    )(value);
  };

export const validateResponsibleGamingLimit =
  (
    limitTypeName: string,
    previousLimit: number | undefined,
    message: ValidationError['message'],
    validatorFunction: ValidatorFunction
  ): Validator =>
  (value, allValues) => {
    if (!previousLimit || value === '' || parseFloat(value) === 0) return { valid: true };

    const limit = +get(allValues, limitTypeName);

    if (!limit) {
      return { valid: true };
    }

    return validatorFunction(limit || Math.abs(previousLimit) / 100, message, true)(value);
  };
